import { useCallback, useState } from 'react';

function deepFreeze(obj) {
  if (Object.isFrozen(obj)) return obj;

  Object.getOwnPropertyNames(obj).forEach(name => {
    if (typeof obj[name] !== 'object' || obj[name] === null) return;
    deepFreeze(obj[name]);
  });

  return Object.freeze(obj);
}

const useFrozenState = (initialValues = {}) => {
  const [state, _setState] = useState(initialValues);
  const setState = useCallback(
    next => _setState((prevState, ...args) => (typeof next === 'function' ? next(deepFreeze(prevState), ...args) : next)),
    [],
  );

  return [deepFreeze(state), setState];
};

export default useFrozenState;
